import React from 'react';
import styled from 'styled-components';

import { User } from '@front/common/src/types/commons';

import { getMembershipQuestions } from '@front/customer/src/modals/membership-paywall/utils';

import { translate } from '@front/i18n';

import { minWidth } from '@front/web-ui/src/styles/mixins';
import Title from '@front/web-ui/src/components/base-text/variants/title';
import Text from '@front/web-ui/src/components/base-text/variants/text';
import Button from '@front/web-ui/src/components/button/button';

import {
  Content,
  MembershipBackground,
  MembershipFaq,
  StickyContainer,
  StyledStickyBottomWrapper,
  StyledWhiteSpacerRoundedBorders,
} from '../common';
import Advantages from '../advantages';

const t = translate('modals.membership_paywall');

const StyledTitle = styled(Title.LG)`
  margin: 20px 0;

  ${minWidth.md`
    margin: 0 0 20px;
  `}
`;

const Subtitle = styled.div`
  margin-bottom: 20px;
`;

type RecurringContentProps = {
  user?: User;
  closePaywall: () => void;
};

const RecurringContent = ({ user, closePaywall }: RecurringContentProps) => (
  <StickyContainer>
    <Content>
      <MembershipBackground>
        <StyledTitle>{t('.title.recurring_cleaning')}</StyledTitle>
        <Subtitle>
          <Text>{t('.subtitle.recurring_cleaning')}</Text>
        </Subtitle>
        <Advantages />
      </MembershipBackground>
      <StyledWhiteSpacerRoundedBorders />
      <MembershipFaq
        title={t('.faq.title')}
        questions={getMembershipQuestions({
          universeReference: 'cleaning',
          isSpotCleaning: false,
          user,
        })}
      />
    </Content>
    <StyledStickyBottomWrapper>
      <Button size='lg' onPress={closePaywall} hasFullWidth>
        {t('.buttons.recurring_cleaning')}
      </Button>
    </StyledStickyBottomWrapper>
  </StickyContainer>
);

export default RecurringContent;
